import styled from 'styled-components';

export const Expander = styled.button`
    padding: 4px;
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: normal;
    color: #6c7485;
    border-radius: 8px;
    border: solid 1px;
    min-width: 27px;
    margin-left: 6px;

    &:hover {
        border: solid 1px;
        color: #6c7485;
    }

    &:focus {
        outline: none;
    }

    .anticon{
        vertical-align: middle;
    }
`;

export const ItemList = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;